"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var QuizPrivilege = function QuizPrivilege(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#333F48' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0001 5C16.0001 2.23872 13.7614 0 11.0001 0C8.23878 0 6.00007 2.23872 6.00007 5V6C6.00007 8.76128 8.23878 11 11.0001 11L11.2242 10.9948C13.9044 10.8634 16.0001 8.66849 16.0001 6V5ZM8.00007 5C8.00007 3.34328 9.34335 2 11.0001 2C12.6568 2 14.0001 3.34328 14.0001 5V6C14.0001 7.60082 12.7424 8.91806 11.1506 8.99631L10.9755 9.0003C9.34335 9 8.00007 7.65671 8.00007 6V5ZM15.5 11.9999C15.1852 11.9999 14.8889 12.1481 14.7 12.3999L11 17.3332L7.3 12.3999C7.11115 12.1481 6.81476 11.9999 6.5 11.9999H6C2.68603 11.9999 0 14.6863 0 17.9999V22.6C0 23.9327 1.08002 25 2.412 25H19.588C20.92 25 22 23.9327 22 22.6V17.9999C22 14.6863 19.314 11.9999 16 11.9999H15.5ZM2 17.9999C2 15.8578 3.68378 14.1088 5.80034 14.0048L6 13.9999L10.2 19.5999C10.6 20.1332 11.4 20.1332 11.8 19.5999L16 13.9999C18.2093 13.9999 20 15.7908 20 17.9999V22.6C20 22.8228 19.8207 23 19.588 23H2.412C2.17934 23 2 22.8228 2 22.6V17.9999ZM17.0001 21.0088H15.0001C14.4478 21.0088 14.0001 20.5611 14.0001 20.0088C14.0001 19.4565 14.4478 19.0088 15.0001 19.0088H17.0001C17.5524 19.0088 18.0001 19.4565 18.0001 20.0088C18.0001 20.5611 17.5524 21.0088 17.0001 21.0088Z",
    fill: color
  }));
};
var _default = QuizPrivilege;
exports.default = _default;